import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type NewChoice = 'message' | 'channel' | 'network' | 'billing' | 'support' | 'browse';

interface Option {
  choice: NewChoice;
  icon: string;
  title: string;
  detail: string;
}

/** The "+" in the conversation list, as a panel in the chat window: what to start. Closes with the choice. */
@Component({
  selector: 'app-chat-new-chooser',
  template: `
    <h2 mat-dialog-title>Start a conversation</h2>
    <mat-dialog-content>
      <button type="button" class="option" *ngFor="let o of options" [attr.data-choice]="o.choice" (click)="ref.close(o.choice)">
        <span class="option-icon"><mat-icon>{{ o.icon }}</mat-icon></span>
        <span class="option-text">
          <span class="option-title">{{ o.title }}</span>
          <span class="option-detail">{{ o.detail }}</span>
        </span>
        <mat-icon class="option-go">chevron_right</mat-icon>
      </button>
    </mat-dialog-content>
  `,
  styleUrls: ['./new-chooser.component.scss'],
})
export class NewChooserComponent {
  readonly options: Option[];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { networkOn: boolean; billingOn?: boolean },
    readonly ref: MatDialogRef<NewChooserComponent, NewChoice>,
  ) {
    this.options = [
      { choice: 'message', icon: 'chat', title: 'New message', detail: 'To one or more colleagues in your practice' },
      { choice: 'channel', icon: 'group_add', title: 'New group', detail: 'A named group for a team or a topic' },
      ...(data.networkOn
        ? [{ choice: 'network' as const, icon: 'medical_services', title: 'Medical professional', detail: 'A colleague outside your practice' }]
        : []),
      ...(data.billingOn
        ? [{ choice: 'billing' as const, icon: 'receipt_long', title: 'Billing team', detail: 'Your billing team on MedicAI Connect' }]
        : []),
      { choice: 'support', icon: 'support_agent', title: 'MedicAI Support', detail: 'Ask the MedicAI team for help' },
      { choice: 'browse', icon: 'groups', title: 'Browse groups', detail: 'Find and join your practice’s public groups' },
    ];
  }
}
